/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import ParentField from '../ParentField';
import ChapterSelect from '../ChapterSelect';

const ChapterField = React.forwardRef(({ ...props }, ref) => (
  <ParentField
    {...props}
    onRedirect={(selectedParent) => `/chapters/${selectedParent.id}`}
    linkText="Chapter setup"
    ref={ref}
  >
    {(parentProps) => <ChapterSelect {...parentProps} />}
  </ParentField>
));

export default ChapterField;
